export default __webpack_public_path__ + "static/media/department.32fbc10d.csv";